export const IDENTIFICATION_NUMBER = "identificationNumber";
export const EMPLOYER_NAME = "employerName";
export const ENABLE_EMPLOYER_CONTRIBUTION = "enableEmployerContribution";
export const CONTRIBUTION_AMOUNT_TYPE_IS_PERCENTAGE = "contributionAmountTypeIsPercentage";
export const CONTRIBUTION_AMOUNT = "amount";
export const CONTRIBUTION_PERCENTAGE = "percentage";
export const FREQUENCY_OF_PAYMENT = "frequencyOfPayment";
